package kz.dentalcrm.app.navigation

import androidx.navigation3.runtime.NavKey
import kotlinx.serialization.Serializable

/**
 * Navigation routes for the application using Navigation3.
 * All routes must implement AppRoute which extends NavKey for type-safe navigation.
 */
sealed interface AppRoute : NavKey

// Auth & Splash
@Serializable
data object SplashRoute : AppRoute

@Serializable
data object LoginRoute : AppRoute

// Main
@Serializable
data object MainRoute : AppRoute

// Main tabs
@Serializable
data object AppointmentsRoute : AppRoute

@Serializable
data object EmployeesRoute : AppRoute

@Serializable
data object PatientsRoute : AppRoute

@Serializable
data object DiagnosisRoute : AppRoute

@Serializable
data object ServicesRoute : AppRoute

@Serializable
data object WarehouseRoute : AppRoute

@Serializable
data object ProtocolsRoute : AppRoute

@Serializable
data object FinanceRoute : AppRoute

@Serializable
data object MenuRoute : AppRoute

// Detail screens with parameters
@Serializable
data class PatientDetailRoute(val patientId: Int) : AppRoute {
    companion object {
        const val RESULT_KEY = "patient_detail_result"
    }

    @Serializable
    data class Result(
        val patientId: Int,
        val updated: Boolean = false,
        val deleted: Boolean = false
    )
}

@Serializable
data class AddPatientRoute(val dummy: Boolean = false) : AppRoute {
    companion object {
        const val RESULT_KEY = "add_patient_result"
    }

    @Serializable
    data class Result(
        val patientId: Int
    )
}

@Serializable
data class DiagnosisDetailRoute(val diagnosisId: String) : AppRoute

@Serializable
data class ProtocolDetailRoute(val protocolId: String) : AppRoute {
    companion object {
        const val RESULT_KEY = "protocol_detail_result"
    }

    @Serializable
    data class Result(
        val protocolId: String,
        val updated: Boolean = false
    )
}

@Serializable
data object AddAppointmentRoute : AppRoute {
    const val RESULT_KEY = "add_appointment_result"

    @Serializable
    data class Result(
        val appointmentId: Int
    )
}

@Serializable
data object AddEmployeeRoute : AppRoute {
    const val RESULT_KEY = "add_employee_result"

    @Serializable
    data class Result(
        val employeeId: Int
    )
}

@Serializable
data class EditAppointmentRoute(val appointmentId: Int) : AppRoute {
    companion object {
        const val RESULT_KEY = "edit_appointment_result"
    }

    @Serializable
    data class Result(
        val appointmentId: Int,
        val updated: Boolean = false
    )
}

@Serializable
data class EditEmployeeRoute(val employeeId: Int) : AppRoute {
    companion object {
        const val RESULT_KEY = "edit_employee_result"
    }

    @Serializable
    data class Result(
        val employeeId: Int,
        val updated: Boolean = false,
        val deleted: Boolean = false
    )
}

@Serializable
data object PositionsRoute : AppRoute

@Serializable
data object ServiceCategoriesRoute : AppRoute

@Serializable
data object SwipeToUnlockDemoRoute : AppRoute

@Serializable
data class AddPatientTreatmentRoute(
    val appointmentId: Int,
    val initialTeeth: List<String> = emptyList()
) : AppRoute {
    companion object {
        const val RESULT_KEY = "add_patient_treatment_result"
    }

    @Serializable
    data class Result(
        val success: Boolean = false
    )
}

@Serializable
data class InitialInspectionRoute(val appointmentId: Int) : AppRoute

@Serializable
data object QuickRepliesRoute : AppRoute

@Serializable
data class ReplyByTemplateRoute(val phone: String) : AppRoute
